export default __webpack_public_path__ + "static/media/legal-scroll.5d93a782.png";